<template>
    <v-card
    class="mx-auto"
    color="grey lighten-5"
    max-width="600"
  ><br>
    <v-card-title>
      
      <v-layout
        column
        align-start
      >
        <div class="caption grey--text text-uppercase">
          Laatste week {{serie.name}} 
        </div>
        
        <div>
          <span
            class="display-2 font-weight-black"
            v-text="lastValue"
          ></span>
          <strong >{{measureType}}</strong>
        </div>
      </v-layout>

      <v-spacer></v-spacer>

      <v-btn icon class="align-self-start" size="28">
        <v-icon>mdi-arrow-right-thick</v-icon>
      </v-btn>
    </v-card-title>

    <v-sheet color="transparent" v-if="serieToData && serieToData.length > 0">
      <v-sparkline
        :smooth="6"
        :gradient="['#f72047', '#ffd200', '#1feaea']"
        :line-width="4"
        :key="lastValue"
        :value="serieToData" 
        auto-draw
        stroke-linecap="round"
      ></v-sparkline>
    </v-sheet>
  </v-card>
</template>
<script>
    const exhale = ms =>
    new Promise(resolve => setTimeout(resolve, ms))

  export default {
    props:['serie', 'serie-data'],
    data: () => ({
      checking: false,      
    }),
    
    computed: {      
      serieToData(){
          let data = []
          if(this.serieData){
              data = this.serieData.serie.map(x => Math.round(x.value));        
          }          
          return data
      },
      measureType(){        
          if(this.serie.unitOfMeasure == 'percentage'){
              return "%"
          }
          if(this.serie.unitOfMeasure == 'celcius'){
              return "Celcius"
          }
          if(this.serie.unitOfMeasure == 'mps'){
              return "Meter/seconden"
          }
          return (this.serie.unitOfMeasure + "C")
      },
      lastValue(){
          let data = this.serieToData[this.serieToData.length -1]
          if(this.serie.unitOfMeasure == 'celcius'){
              return data / 10;
          }
          return data
      }
    },  
    mounted(){

    }  
  }

</script>
<style scoped></style>